import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Style from './PromotionalBanner.style';
import PropTypes from 'prop-types';

export const PromotionalBanner = ({ couponCode, leftImage, rightImage, mobileImage, children, backgroundColor }) => {
  const history = useHistory();
  const [hasNotification, setHasNotification] = useState(false);

  const handleClick = () => {
    history.push(`/buy/?coupon=${couponCode}`);
  };

  useEffect(() => {
    const check = () => {
      const exists = !!document.querySelector('.notification-box');
      setHasNotification(exists);
    };

    check();

    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Style
      backgroundColor={backgroundColor}
      className="promotional-banner"
      onClick={handleClick}
      role="button"
      hasNotification={hasNotification}
      aria-label="Gehe zur Aktion"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="content-wrapper">
        <div className="wrapper left-img-wrapper">{leftImage}</div>
        <div className="text-wrapper">{children}</div>
        <div className="wrapper right-img-wrapper">{rightImage}</div>
      </div>
      {mobileImage}
    </Style>
  );
};

PromotionalBanner.propTypes = {
  couponCode: PropTypes.string.isRequired,
  leftImage: PropTypes.node.isRequired,
  rightImage: PropTypes.node.isRequired,
  mobileImage: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string
};
